import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import styles from './styles.module.css';
import classNames from 'classnames';

export const AppTemplate = ({ navigation }: { navigation?: ReactNode }) => {
  return (
    <div className={styles.layout}>
      {navigation && <div className={styles.nav}>{navigation}</div>}
      <main className={classNames(styles.main, !navigation && styles.noNav)}>
        <Outlet />
      </main>
    </div>
  );
};
